export enum MULTIMEDIA {
  LIST = '/multimedia/list',
  ADD = '/multimedia/add',
  EDIT = '/multimedia/edit/:id',
}
